export class GetCurrentStatesByOrdersInput {
    ordersId: number[];
}